import { getSection } from "@wix/ambassador-appmarket-v1-section/http";
import { SectionsPlacement } from "@wix/ambassador-appmarket-v1-section/types";
import { queryMarketListing } from "@wix/ambassador-devcenter-app-market-listing-v1-market-listing/http";
import { queryApp } from "@wix/ambassador-devcenter-apps-v1-app/http";
import { search } from "@wix/ambassador-devcenter-ams-v1-app-market-search/http";
export const getBenefitApps = async (httpClient, experiments) => {
    if (!experiments.enabled("specs.app-market.AppBenefits")) {
        return [];
    }
    try {
        const { data: { sections }, } = await httpClient.request(getSection({
            placement: SectionsPlacement.APP_BENEFITS,
        }));
        let appIds, deprecatedAppIds, fliteredAppIds;
        const filterPicassoApps = experiments.enabled("specs.dcc.filterBundlesAndBenefitsAppsForPicasso");
        if (filterPicassoApps) {
            const appIdsBeforeFilter = sections.map(({ app: { appId } }) => appId);
            const fliteredApp = await httpClient.request(search({
                filter: { $and: [{ doc_id: { $in: appIdsBeforeFilter } }] },
            }));
            fliteredAppIds =
                fliteredApp.data?.webSolutions?.map((webSolutions) => webSolutions.id) ?? [];
        }
        else {
            deprecatedAppIds = sections.map(({ app: { appId } }) => appId);
        }
        appIds = filterPicassoApps ? fliteredAppIds : deprecatedAppIds;
        const [{ data: { marketListing }, }, { data: { apps: dcApps }, },] = await Promise.all([
            httpClient.request(queryMarketListing({
                query: {
                    filter: {
                        appId: {
                            $in: appIds,
                        },
                    },
                },
            })),
            httpClient.request(queryApp({
                query: {
                    filter: {
                        id: {
                            $in: appIds,
                        },
                    },
                },
            })),
        ]);
        const latestListings = marketListing.reduce((acc, listing) => {
            const existingListing = acc.find((l) => l.appId === listing.appId);
            if (!existingListing ||
                listing?.updatedDate > existingListing?.updatedDate) {
                acc = acc.filter((l) => l.appId !== listing.appId);
                acc.push(listing);
            }
            return acc;
        }, []);
        return latestListings.map((listing) => {
            const relatedDcApp = dcApps.find((app) => app.id === listing.appId);
            return {
                appId: listing?.appId,
                appInfo: {
                    name: listing?.basicInfo.name,
                    icon: listing?.assetsMap?.appIcon?.assets?.[0]?.url,
                    teaser: listing?.basicInfo.teaser,
                    slug: relatedDcApp?.slug,
                },
            };
        });
    }
    catch (e) {
        return [];
    }
};
//# sourceMappingURL=benefit-apps-api.js.map